import React, { Component } from "react";
import './Menu.css';
import logo from '../../assets/images/logo.png';
import inOrange from '../../assets/images/inOrange.png';
import ytOrange from '../../assets/images/ytOrange.png';
import fbOrange from '../../assets/images/fbOrange.png';
import twitOrange from '../../assets/images/twitOrange.png';
import siteOrange from '../../assets/images/siteOrange.png';
import * as jwt_decode from "jwt-decode";

import { MDBRow, MDBCol } from "mdbreact";
let sessionLocal = sessionStorage.getItem('auth'),
    auth

if (sessionLocal !== null) {
    const varLocal = jwt_decode(sessionLocal, 'r3g1str0UfG');
    auth = varLocal.Continuar
}

class Menu extends Component {

    UNSAFE_componentWillMount () {
        if (auth === null) {
            auth = 0;
        }
    }

    salir = () => {
        sessionStorage.removeItem('auth');
        window.location = "/carnetizacion";
    };

    render() {
        return (
            <div className="container-fluid">
                <MDBRow className="mt-3 mb-3 justify-content-between">
                    <MDBCol className="col-12 col-md-4 col-lg-2 wow bounceInDown animated d-flex align-items-center justify-content-center">
                        <div className="wrap-logo">
                            <img src={logo} className="img-fluid" alt="Logo UFG" />
                        </div>
                    </MDBCol>
                    <MDBCol className="col-md-4 col-lg-4 col-xl-3 d-flex align-items-center justify-content-around">
                        <div className="social-icons">
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.instagram.com/nuevo_ingresoufg"
                                className=""
                            >
                                <img src={inOrange} className="" alt="Instagram"/>
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.youtube.com/user/redsocialufg"
                                className=""
                            >
                                <img src={ytOrange} className="" alt="Youtube" />
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://es-la.facebook.com/ufgoficial"
                                className=""
                            >
                                <img src={fbOrange} className="" alt="Facebook"/>
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://twitter.com/UFGoficial"
                                className="letterLink"
                            >
                                <img src={twitOrange} className="" alt="Twitter"/>
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.ufg.edu.sv/"
                                className=""
                            >
                                <img src={siteOrange} className="" alt="Website"/>
                            </a>
                        </div>
                    </MDBCol>
                </MDBRow>

                {
                    auth === 1 ? (
                        <MDBRow>
                            <MDBCol size="12" sm="12" md="2" lg="2" xl="2" className="filaSalir offset-lg-8 offset-md-8 offset-xl-10">
                                <button className="boton lightBlue" onClick={this.salir}>CERRAR SESI&Oacute;N</button>
                            </MDBCol>
                        </MDBRow>
                    ) : (
                            ""
                        )
                }

            </div >
        );
    }
}
export default Menu;